import { v4 as uuidv4 } from 'uuid';

export function ProductIdentifier(props) {
	return {
		componentName: 'ProductIdentifier',
		componentId: uuidv4(),
		props: {},
		childrenComponents: [],
	};
}
